import { ERoleType, ROLE_INVITE_PERMISSIONS } from '../constants'
import { TRole } from '../types'

/**
 * Get list of roles that the inviter is allowed to assign
 *
 * @param inviterRole - Role of the user sending invitations
 * @returns Array of roles that can be assigned
 *
 * @example
 * getAvailableRoles(RoleType.ORG_ADMIN)
 * [RoleType.ORG_ADMIN, RoleType.PROJECT_LEAD, RoleType.TEAM_MEMBER]
 *
 * getAvailableRoles(RoleType.PROJECT_LEAD)
 * [RoleType.TEAM_MEMBER]
 */
export const getAvailableRoles = (inviterRole: TRole): ERoleType[] => {
  return ROLE_INVITE_PERMISSIONS[inviterRole] || []
}
